import Head from "next/head";
import BreadcrumbScrollCX from "../../../components/Elements/BreadcrumbScrollCX/BreadcrumbScrollCX";
import cx from "classnames";
import styles from "../../../styles/CXpages.module.css";
import ogCX from "../../../images/ogCX.png";
import { useRef, useState } from "react";
import { useScroll, motion, calcLength } from "framer-motion";
import { useDetectScroll } from "@smakss/react-scroll-direction";
import cxVline from "../../../images/cxVline.svg";
import useIntersection from "../../../components/Services/useIntersection";
import Image from "next/image";
import circle from "../../../images/circle.svg";
import linkShare from "../../../images/linkShare.svg";
import emailShare from "../../../images/emailShare.svg";
import telegramShare from "../../../images/telegramShare.svg";
import whatsappShare from "../../../images/whatsappShare.svg";
import iPhoneFrame from "../../../images/iPhoneFrame.svg";
import cxBrand1 from "../../../images/cxBrand1.svg";
import cxBrand2 from "../../../images/cxBrand2.svg";
import cxBrand3 from "../../../images/cxBrand3.svg";

import { useRouter } from "next/router";
import Snackbar from "@mui/material/Snackbar";
import like from "../../../images/like.svg";
import dislike from "../../../images/dislike.svg";
import Link from "next/link";
import cx1 from "../../../images/cx1.svg";
import cx2 from "../../../images/cx2.svg";
import cx3 from "../../../images/cx3.svg";
import cx4 from "../../../images/cx4.svg";
import cxArrow from "../../../images/cxArrow.svg";

import cxVal1 from "../../../images/cxVal1.svg";
import cxVal2 from "../../../images/cxVal2.svg";
import cxVal3 from "../../../images/cxVal3.svg";
import cxVal4 from "../../../images/cxVal4.svg";

const Index = () => {
  const router = useRouter();

  const pageDetails = {
    pageTitle: "نقش مطالعات برند در سنجش تجربه مشتریان دیجی‌کالا",
    pagePath: `https://about.digikala.com${router.asPath}`,
    pageDesc:
      "برند دیجی‌کالا چقدر برایتان اهمیت دارد؟ در این مقاله با مطالعات برند به عنوان یکی از راه‌های اصلی شناخت مشتریان و دریافت بازخورد آنها با هدف حفظ خوشنامی برند آشنا می‌شوید.",
  };

  // toast handler after link copy
  const [openToast, setOpenToast] = useState(false);
  const onShareHandler = () => {
    navigator.clipboard.writeText(pageDetails.pagePath);
    openToastHandler();
  };
  const openToastHandler = () => {
    setOpenToast(true);
  };
  const closeToastHandler = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenToast(false);
  };
  // end of toast handler after link copy

  const ref1 = useRef();
  const ref2 = useRef();
  const ref3 = useRef();
  const ref4 = useRef();

  const refBillion = useRef();

  const { scrollYProgress: scroll1 } = useScroll({
    target: ref1,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll2 } = useScroll({
    target: ref2,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll3 } = useScroll({
    target: ref3,
    offset: ["start end", "end end"],
  });
  const { scrollYProgress: scroll4 } = useScroll({
    target: ref4,
    offset: ["start end", "end end"],
  });

  const { scrollYProgress: scrollAll } = useScroll({
    offset: ["start end", "end end"],
  });
  const spring = {
    type: "spring",
    damping: 10,
    stiffness: 1,
  };

  const [scrollDir] = useDetectScroll({});

  const ref1inViewport = useIntersection(ref1, "0px");
  const ref2inViewport = useIntersection(ref2, "0px");
  const ref3inViewport = useIntersection(ref3, "0px");
  const ref4inViewport = useIntersection(ref3, "0px");

  return (
    <>
      <Head>
        <title>{pageDetails.pageTitle}</title>
        <meta name="viewport" content="initial-scale=1.0, width=device-width" />
        <meta charSet="utf-8" />
        <meta name="description" content={pageDetails.pageDesc} />
        <link rel="icon" type="image/x-icon" href="/faviconNew.svg"></link>
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-video-preview:-1, max-image-preview:large"
        />
        <meta property="og:locale" content="fa_IR" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content={pageDetails.pageTitle} />
        <meta property="og:url" content={pageDetails.pagePath} />
        <meta property="og:site_name" content="درباره گروه دیجی‌کالا" />
        <meta property="og:image" itemProp="image" content="/ogCX.png" />
        <meta property="og:image:width" content="665" />
        <meta property="og:image:height" content="370" />
        <meta property="og:image:alt" content={pageDetails.pageTitle} />
        <meta property="og:image:type" content="image/png" />
        <meta
          property="og:site_name"
          content="درباره گروه دیجی‌کالا"
          key="ogsitename"
        />
        <meta
          property="og:title"
          content={pageDetails.pageTitle}
          key="ogtitle"
        />
        <meta
          property="og:description"
          content={pageDetails.pageDesc}
          key="ogdesc"
        />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageDetails.pageTitle} />
        <meta name="twitter:site" content="درباره گروه دیجی‌کالا" />
        <meta
          name="twitter:image"
          content="https://about.digikala.com/ogCX.png"
        />
        <meta name="twitter:description" content={pageDetails.pageDesc} />
      </Head>

      <Snackbar
        open={openToast}
        autoHideDuration={2000}
        onClose={closeToastHandler}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        message={
          <div className="w-100 d-flex align-items-center justify-content-between">
            <span className={cx(styles.toasTextStyles, "d-flex", "w-100")}>
              لینک مطلب کپی شد!
            </span>
          </div>
        }
      />

      <BreadcrumbScrollCX
        title="شاخص‌های اصلی"
        routeOne="/customer-experience/"
        titleOne="درباره تجربه مشتریان"
        routeTwo="/customer-experience/brand-surveys/"
        titleTow="شاخص‌های اصلی"
      />

      <div className={cx(styles.mainPage)}>
        <div
          className={cx(
            styles.progressBarMain,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll1 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll2 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll3 }}
            transition={spring}
          />
          <motion.div
            className={cx(styles.progressBarInner)}
            style={{ scaleX: scroll4 }}
            transition={spring}
          />

          {/* On Mobile  */}
          <motion.div
            className={cx(styles.progressBarInnerMobile)}
            style={{ scaleX: scrollAll }}
            transition={spring}
          />
        </div>
        <div
          className={cx(
            styles.progressBarMainTitles,
            scrollDir !== "down" ? styles.Stick : styles.notStick
          )}
        >
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref1inViewport
                ? ref2inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref1?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
          {/* <div className={cx(styles.progressBarInnerVline , "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref2inViewport
                ? ref3inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref2?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {/* <h5></h5> */}
          </div>
          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref3inViewport
                ? ref4inViewport
                  ? styles.mobileShrinkable
                  : ""
                : styles.mobileShrinkable
            )}
            onClick={() =>
              ref3?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          >
            {/* <h5></h5> */}
          </div>
          {/* <div className={cx(styles.progressBarInnerVline ,  "d-none d-md-block")}></div> */}
          <div
            className={cx(
              styles.progressBarInnerTitle,
              ref4inViewport ? "" : styles.mobileShrinkable
            )}
            onClick={() =>
              ref4?.current?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              })
            }
          ></div>
        </div>

        <div className={cx(styles.pageContainer)}>
          <div ref={ref1} className={cx(styles.experience)}>
            <h1 className="py-2">
              نقش مطالعات برند در سنجش تجربه مشتریان دیجی کالا
            </h1>
            <p>
              حفظ خوشنامی برند، مهم‌ترین مأموریت تیم برند دیجی‌کالاست و کیفیت
              تجربه مشتریان از سطح خدمات، نقش بسزایی در خوشنامی برند دارد. یکی
              از شاهراه‌های دریافت بازخورد و سنجش تجربه مشتریان،
              افکارسنجی‌هایی‌ست که تیم برند دیجی‌کالا برگزار می‌کند.
              کاربردی‌ترین ابزارهای تیم برند برای دریافت بازخورد مشتریان:
            </p>

            <div className="row py-4">
              <div className="col-12 col-md-4">
                <div className={cx(styles.marketingMetrics)}>
                  <div className={cx(styles.iconHeight)}>
                    <Image
                      src={cxBrand1}
                      alt="survey"
                      className={cx(styles.brandImagesIcon)}
                    />
                  </div>
                  <div className="py-2">
                    <h6>نظرسنجی‌های متنی و تلفنی</h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div
                  className={cx(
                    styles.marketingMetrics,
                    styles.desktopBorderRL
                  )}
                >
                  <div className={cx(styles.iconHeight)}>
                    <Image
                      src={cxBrand2}
                      alt="focus group"
                      className={cx(styles.brandImagesIcon)}
                    />
                  </div>
                  <div className="py-2">
                    <h6>برگزاری گروه‌های کانونی</h6>
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-4">
                <div className={cx(styles.marketingMetrics)}>
                  <div className={cx(styles.iconHeight)}>
                    <Image
                      src={cxBrand3}
                      alt="brand surveys"
                      className={cx(styles.brandImagesIcon)}
                    />
                  </div>
                  <div className="py-2">
                    <h6>تحقیقات سنجش ارزش ویژه برند و سلامت برند</h6>
                  </div>
                </div>
              </div>
            </div>

            <p>
              این گزارش‌ها به تیم برند کمک می‌کند تا از مهمترین دلایل رضایت و
              نارضایتی مشتریان دیجی‌کالا آگاه شود و بر اساس موضوع، واحدهای مختلف
              سازمان را برای اصلاح رویه‌ها یا ارتقای سطح خدمات دور میز
              تصمیم‌گیری جمع کند.
            </p>
          </div>

          <div ref={ref2} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>

            <div className="d-block w-100">
              <h2>سنجش ارزش ویژه برند و سلامت برند</h2>
              <p>
                استفاده از این ابزار کمک می‌کند تا یک برند در ذهن مشتری مثبت،
                متمایز و مطلوب جلوه کند یا باعث شود مخاطبان، آن برند را در میان
                سایر رقبا انتخاب کنند. این مدل، بر ارزیابی ۴ شاخص برندینگی تاکید
                دارد:
              </p>

              <div className="row py-2">
                <div className="col-6 col-md-3">
                  <div className={cx(styles.brandValues)}>
                    <Image
                      src={cxVal1}
                      alt="Email"
                      style={{ height: "120px" }}
                    />
                    <div className="py-2">
                      <h6>تمایز</h6>
                      <h6>Differentiation</h6>
                    </div>
                    <p>
                      مشتریان چقدر می‌توانند ماهیت و نشانه‌های برند ما را از
                      سایر رقبا تشخیص دهند؟
                    </p>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className={cx(styles.brandValues)}>
                    <Image
                      src={cxVal2}
                      alt="Plus"
                      style={{ height: "120px" }}
                    />
                    <div className="py-2">
                      <h6>ارتباط</h6>
                      <h6>Relevance</h6>
                    </div>
                    <p>چقدر یک برند برای مشتریانش مناسب و معنادار است؟</p>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className={cx(styles.brandValues)}>
                    <Image
                      src={cxVal3}
                      alt="Calls"
                      style={{ height: "120px" }}
                    />
                    <div className="py-2">
                      <h6>احترام</h6>
                      <h6>Esteem</h6>
                    </div>
                    <p>مشتریان تا چه اندازه به برند اهمیت می‌دهند؟</p>
                  </div>
                </div>
                <div className="col-6 col-md-3">
                  <div className={cx(styles.brandValues)}>
                    <Image
                      src={cxVal4}
                      alt="Chats"
                      style={{ height: "120px" }}
                    />
                    <div className="py-2">
                      <h6>دانش</h6>
                      <h6>Knowledge</h6>
                    </div>
                    <p>
                      مشتریان چقدر هویت برند را درک کرده‌اند و چقدر از خدمات آن
                      آگاهی دارند؟
                    </p>
                  </div>
                </div>
              </div>

              <p>
                در دیجی‌کالا این تحقیقات به صورت سالانه و در بهار هر سال انجام
                می‌شود.
              </p>
              <p>
                در بهار سال ۱۴۰۱، کارشناسان تیم برند دیجی‌کالا برای درک میزان
                شناخت مشتریان از خدمات دیجی‌کالا، پرسشنامه‌ای طراحی کردند. پس از
                گردآوری و تحلیل پاسخ‌های مشتریان، کارشناسان تیم برند متوجه شدند
                که بخش عمده‌ای از مشتریان دیجی‌کالا نسبت به بعضی رویه‌ها و خدمات
                مثل شیوه بازگرداندن کالاها یا دیجی‌کلاب (باشگاه مشتریان
                دیجی‌کالا) اطلاع کمی دارند.
              </p>
              <p>
                علاوه‌بر تحقیقات مربوط به سنجش جایگاه و سلامت برند در ذهن
                مشتریان، تحقیقات فصلی (یا بسته به شرایط به صورت ماهانه) نیز
                برگزار می‌شود. این تحقیقات در قالب برقراری تماس‌های تلفنی یا
                پرسشنامه طراحی می‌شوند. در این مدل از تحقیقات، مشتریان به
                دسته‌های گوناگونی تقسیم می‌شوند تا نیازمندی‌های هر گروه متناسب
                با همان گروه سنجیده شود. برای مثال، مشتریان وفادار و باسابقه
                انتظار متفاوتی نسبت به مشتریانی دارند که تازه به جمع مشتریان
                دیجی‌کالا پیوسته‌اند.
              </p>
              <p>
                در آخرین تحقیق صورت گرفته در این مدل، بیش از ۳۰درصد مشتریان جدید
                دیجی‌کالا از دلایل چند مرسوله‌ای شدن سفارش خود باخبر نبودند.
                درحالی‌که مهمترین دغدغه مشتریان باسابقه دیجی‌کالا، دریافت
                به‌موقع سفارش بوده است.
              </p>
            </div>
          </div>

          <div ref={ref3} className={cx(styles.experience2)}>
            <div className={cx(styles.cxVline)}>
              <Image src={cxVline} alt="Line" />
            </div>
            <div className={cx(styles.cxVlineVl)}></div>
            <div className="d-block w-100">
              <h2>سایر راه‌های شنیدن صدای شما</h2>
              <div className={cx("row", styles.otherChannelsRow)}>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/customer-service/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx1} alt="Call Center" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>تماس مشتریان</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/social-media-analysis/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx3} alt="Social media" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>شبکه‌های اجتماعی</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className={cx("col-12 col-md-4", styles.otherChannelsCol)}>
                  <Link href="/customer-experience/metric/">
                    <div className={cx(styles.otherChannelsInnerContainer)}>
                      <Image src={cx4} alt="Social media" className="my-4" />
                      <div
                        className={cx(styles.otherChannelsInnerBottomContainer)}
                      >
                        <div className={cx(styles.otherChannelsInnerBottom)}>
                          <h6>شاخص‌هاس تجربه مشتریان</h6>
                          <Image
                            src={cxArrow}
                            alt="left arrow"
                            className={cx(styles.leftArrow)}
                          />
                        </div>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          <div ref={ref4} className={cx(styles.experienceShare)}>
            <div className={cx(styles.share)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>به اشتراک بگذارید</h6>
              </div>
              <div className="d-block">
                <span
                  onClick={onShareHandler}
                  className={cx(styles.copyLink, "me-3")}
                >
                  <Image src={linkShare} alt="Link Share" />
                </span>
                <a
                  className="me-3"
                  target="_blank"
                  rel="noreferrer"
                  href={`mailto:?subject=${pageDetails.pageTitle}
                                &${pageDetails.pagePath}
                                &body=سلام %0A این صفحه از سایت درباره دیجی‌کالا رو ببین.%0A سپاس
                                `}
                >
                  <Image src={emailShare} alt="Email Share" />
                </a>
                <a
                  className="me-3"
                  rel="noreferrer"
                  target="_blank"
                  href={`https://t.me/share/url?url=${
                    pageDetails.pagePath
                  }?text=${encodeURIComponent(pageDetails.pageTitle)}`}
                >
                  <Image src={telegramShare} alt="Telegram Share" />
                </a>
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={`whatsapp://send?text=${encodeURIComponent(
                    pageDetails.pagePath
                  )}`}
                  data-action="share/whatsapp/share"
                >
                  <Image src={whatsappShare} alt="Whatsapp Share" />
                </a>
              </div>
            </div>

            <div className={cx(styles.comment)}>
              <div className="d-block">
                <h6 className={cx(styles.shareTitle)}>
                  آیا این مطلب برایتان مفید بود؟
                </h6>
              </div>
              <div className="d-block">
                <span className="me-3">
                  <Image
                    src={dislike}
                    alt="Dislike"
                    style={{ cursor: "pointer" }}
                  />
                </span>
                <span>
                  <Image src={like} alt="Like" style={{ cursor: "pointer" }} />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Index;
